<script>
import BaseIcon from "./BaseIcon";

export default {
  name: "BaseButton",
  components: { BaseIcon },
  props: {
    id: String,
    isLoading: Boolean,
    isDisabled: Boolean,
    type: String,
    className: String,
    action: Function,
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
  computed: {
    addClass() {
      return [
        { loading: this.isLoading },
        { disabled: this.isDisabled },
        "base-button",
        this.className,
      ];
    },
  },
};
</script>
<template>
  <button
    :disabled="this.isLoading || this.isDisabled"
    @click="onClick"
    :class="addClass"
    :id="id"
    :type="type"
  >
    <slot />
    <base-icon
      v-if="this.isLoading"
      class="loader-icon"
      name="loader"
    ></base-icon>
  </button>
</template>
